import _ from 'lodash'

export const availableGendersByValue = state => {
    return _.keyBy(state.availableGenders, 'value')
}

export const availableSpecialistsByIds = state => {
    return _.keyBy(state.availableSpecialists, 'id')
}

export const canSeqPGTSpecialists = state => {
    return _.filter(state.availableSpecialists, (s) => {
        return s.canSeqPGT
    })
}

export const canSignReportsSpecialists = state => {
    return _.filter(state.availableSpecialists, (s) => {
        return s.canSignReports
    })
}

export const availableClinicalDataByValues = state => {
    return _.keyBy(state.availableClinicalData, 'value')
}